import { Directive, ElementRef, OnInit , Input, NgModule } from '@angular/core';
import { AuthenticationService } from './Authentication.service';

enum RoleActionEnum {
    DISABLE_ELEMENT,
    HIDE_ELEMENT
}

@Directive({
    selector: '[authorizeRole]'
})
export class AuthorizeRoleDirective {
    @Input('authorizeRole') roles: any;
    @Input('disable-role-action') disableRoleAction: any;
    test:boolean = false;

    constructor(private el: ElementRef, private authorizationService: AuthenticationService) { }
 
    ngOnInit() {
        let roleAction: RoleActionEnum = RoleActionEnum.HIDE_ELEMENT;

        if(this.disableRoleAction != undefined && this.disableRoleAction != null){
            roleAction = RoleActionEnum.DISABLE_ELEMENT;
        }
        
        if (!this.hasPermission()) { // default role action is display none.
            if(roleAction == RoleActionEnum.HIDE_ELEMENT){
                this.el.nativeElement.style.display = 'none';
            }
            else if(roleAction == RoleActionEnum.DISABLE_ELEMENT){
                this.el.nativeElement.classList.add('app-disabled');
            }
        }
    }

    hasPermission(){         
        let isResponsable  = JSON.parse(sessionStorage.getItem("isResponsable"));        
        return this.authorizationService.IsAuthenticated() && isResponsable;
    }
}